import { ApolloProvider } from "@apollo/client"
import React from "react"
import { client } from "./lib/apolloClient"
import AuthProvider from "./src/components/auth/AuthProvider"
import Layout from "./src/components/Layout"
import TransitionState from "./src/components/page-transitions/context/TransitionState"
import Scripts from "./src/components/Scripts"
import Wrapper from "./src/components/search/context"
import GlobalContext from "./src/context/GlobalContext"
import { wrapPageInSmoothWrapper } from "./src/utils/wrapPageInSmoothWrapper"

export const wrapRootElement = ({ element }, options) => (
  <ApolloProvider client={client}>
    <TransitionState>
      <AuthProvider>
        <GlobalContext>
          <Wrapper element={element} {...options} />
        </GlobalContext>
      </AuthProvider>
    </TransitionState>
  </ApolloProvider>
)

export const wrapPageElement = ({ element }, options) => {
  const { usePageTransitions, useSiteConfigFiles } = options
  if (useSiteConfigFiles) return element

  // if using page transitions, we need to add the layout component here. Otherwise, it is added in the page component
  const PageWrapper = usePageTransitions ? Layout : React.Fragment

  return (
    <PageWrapper>
      <Scripts options={options} />
      {element}
    </PageWrapper>
  )
}

export function onRouteUpdate({ location }, { googleTagManagerId }) {
  if (process.env.NODE_ENV === `production` && googleTagManagerId) {
    if (typeof window.dataLayer !== "undefined") {
      setTimeout(() => {
        window.dataLayer.push({
          event: "virtualPageView",
          virtualPageURL: location.pathname,
          virtualPageTitle: document.title,
        })
      }, 500) // wrap inside a timeout to ensure the title has properly been changed)
    }
  }
}

wrapPageInSmoothWrapper()
